module.exports = __webpack_public_path__ + "img/02.363cda8c.jpg";